import React from 'react';
import styles from './styles.module.css';

const WIDTH = 168;
const HEIGHT = 44;
const PAD = 5;

/**
 * Linha de evolução em miniatura, sem eixos: só a forma da série e o último
 * ponto em destaque. Usada na prévia ao passar o mouse sobre uma medida.
 */
const MeasureSparkline = ({ values }) => {
  if (!values || values.length < 2) return null;

  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const stepX = (WIDTH - PAD * 2) / (values.length - 1);
  const points = values.map((value, index) => ({
    x: PAD + index * stepX,
    y: PAD + (1 - (value - min) / span) * (HEIGHT - PAD * 2),
  }));
  const last = points[points.length - 1];

  return (
    <svg className={styles.sparkline} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} width={WIDTH} height={HEIGHT} aria-hidden="true">
      <polyline
        className={styles.sparklineLine}
        points={points.map((point) => `${point.x},${point.y}`).join(' ')}
      />
      {points.map((point, index) => (
        <circle key={index} className={styles.sparklineDot} cx={point.x} cy={point.y} r={2} />
      ))}
      <circle className={styles.sparklineLast} cx={last.x} cy={last.y} r={3.5} />
    </svg>
  );
};

export default MeasureSparkline;
